/* unplugin-vue-components disabled */import { render } from "./QuizPreamble.vue?vue&type=template&id=1dac0442&scoped=true&ts=true"
import script from "./QuizPreamble.vue?vue&type=script&lang=ts"
export * from "./QuizPreamble.vue?vue&type=script&lang=ts"

import "./QuizPreamble.vue?vue&type=style&index=0&id=1dac0442&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dac0442"]])

export default __exports__